import {API_URLS} from '@/const/urls';
import {http} from '@/helper/http';

export const marginTradeApi = {
  getBorrowInterestHistory(query) {
    return http.get(API_URLS.MT_BORROW_INTERESTS_HISTORY, {query});
  },
  getFundsHistory(query) {
    return http.get(API_URLS.MT_FUNDS_HISTORY, {query});
  },
  getBorrowHistory(query) {
    return http.get(API_URLS.MT_BORROW_HISTORY, {query});
  },
  getRepayHistory(query) {
    return http.get(API_URLS.MT_REPAY_HISTORY, {query});
  },
  borrow(params) {
    return http.post(API_URLS.MT_BORROW, {params});
  },
  replay(params) {
    return http.post(API_URLS.MT_REPAY, {params});
  },
  getOrderHistory(query) {
    return http.get(API_URLS.MT_ORDER_HISTORY, {query});
  },
  getTradeHistory(query) {
    return http.get(API_URLS.MT_TRADE_HISTORY, {query});
  },
  transfer(params) {
    return http.post(API_URLS.COPY_TRADE_ACCOUNT_TRANSFER, {params});
  },
  borrowLimit(query) {
    return http.get(API_URLS.MT_TRADE_LIMIT, {query});
  },
  getSysRemainingBorrow(query) {
    return http.get(API_URLS.MARGIN_SYS_REMAINING_BORROW, {query});
  },
  getUtaSysRemainingBorrow(query) {
    return http.get(API_URLS.MARGIN_SYS_REMAINING_BORROW_UTA, {query});
  },
  getWallets(query = {}) {
    return http.get(API_URLS.MT_WALLETS, {query});
  },
};
